/* @ts-self-types="./sched.d.ts" */

export class ApiClient {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ApiClientFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_apiclient_free(ptr, 0);
    }
    /**
     * @param {string} base_url
     */
    constructor(base_url) {
        const ptr0 = passStringToWasm0(base_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.apiclient_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        ApiClientFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
}
if (Symbol.dispose) ApiClient.prototype[Symbol.dispose] = ApiClient.prototype.free;

export class ConsolidationAnalysis {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ConsolidationAnalysisFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_consolidationanalysis_free(ptr, 0);
    }
}
if (Symbol.dispose) ConsolidationAnalysis.prototype[Symbol.dispose] = ConsolidationAnalysis.prototype.free;

export class DataManager {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DataManagerFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_datamanager_free(ptr, 0);
    }
    /**
     * @param {SafeData} data
     * @param {DatabaseCommand} command
     * @returns {Promise<void>}
     */
    static apply_command(data, command) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_apply_command(data.__wbg_ptr, command);
        return ret;
    }
    /**
     * This method is key to how this data manager works. Apply a command to make a change, and then trigger notifications
     * to all relevant subscribers.
     *
     * There is a lot of room for optimization here so that only the relevant parts of the cache are invalidated and so only
     * the minimum number of subscribers is notified. However that may not be necessary for a while.
     * @param {SafeData} data
     * @param {DatabaseCommand[]} commands
     * @returns {Promise<void>}
     */
    static apply_commands(data, commands) {
        _assertClass(data, SafeData);
        const ptr0 = passArrayJsValueToWasm0(commands, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.datamanager_apply_commands(data.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {WrappedConsolidationAnalysis} consolidation_analysis
     * @param {Answer} answer
     * @returns {Promise<void>}
     */
    static apply_consolidation_answer(data, consolidation_analysis, answer) {
        _assertClass(data, SafeData);
        _assertClass(consolidation_analysis, WrappedConsolidationAnalysis);
        const ret = wasm.datamanager_apply_consolidation_answer(data.__wbg_ptr, consolidation_analysis.__wbg_ptr, answer);
        return ret;
    }
    /**
     * Apply CQRS events received via WebSocket.
     *
     * Takes a JSON string containing `Vec<StoredEvents>` (the raw WebSocket
     * message payload). Deserializes and applies them to the remote database
     * copy, then notifies subscribers.
     *
     * Safe to call with events the client already has — `apply_remote_events`
     * skips any events older than `last_event_id`.
     * @param {SafeData} data
     * @param {string} events_json
     * @returns {Promise<void>}
     */
    static apply_remote_events_from_json(data, events_json) {
        _assertClass(data, SafeData);
        const ptr0 = passStringToWasm0(events_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.datamanager_apply_remote_events_from_json(data.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @returns {Promise<WrappedConsolidationAnalysis>}
     */
    static build_consolidation_analysis(data) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_build_consolidation_analysis(data.__wbg_ptr);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {WrappedApiClient} api_client
     * @param {string} token
     * @returns {Promise<void>}
     */
    static fetch_and_apply_new_remote_events(data, api_client, token) {
        _assertClass(data, SafeData);
        _assertClass(api_client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.datamanager_fetch_and_apply_new_remote_events(data.__wbg_ptr, api_client.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * Return the last event ID which was received from the remote API
     * @param {SafeData} data
     * @returns {Promise<number | undefined>}
     */
    static get_last_remote_event_id(data) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_get_last_remote_event_id(data.__wbg_ptr);
        return ret;
    }
    /**
     * Return the commands from pending changes as a JSON string, excluding
     * any IDs listed in `exclude_ids_json` (which are already claimed by an
     * in-flight batch).
     *
     * Returns `null` if there are no unsent pending changes.
     * @param {SafeData} data
     * @param {string} exclude_ids_json
     * @returns {Promise<string | undefined>}
     */
    static get_unsent_pending_commands_as_json(data, exclude_ids_json) {
        _assertClass(data, SafeData);
        const ptr0 = passStringToWasm0(exclude_ids_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.datamanager_get_unsent_pending_commands_as_json(data.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @returns {Promise<boolean>}
     */
    static is_online(data) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_is_online(data.__wbg_ptr);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @returns {Promise<PendingChange[]>}
     */
    static list_pending_changes(data) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_list_pending_changes(data.__wbg_ptr);
        return ret;
    }
    /**
     * This exists only for serialization debugging purposes
     * @param {string} workspace_id
     * @returns {Promise<any | undefined>}
     */
    static load_database_from_storage_but_do_not_deserialize_yet(workspace_id) {
        const ptr0 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.datamanager_load_database_from_storage_but_do_not_deserialize_yet(ptr0, len0);
        return ret;
    }
    /**
     * Remove pending changes by their UUIDs (called when a batch is confirmed
     * by the server). Triggers rebuild_from_base and subscriber notifications.
     * @param {SafeData} data
     * @param {string} ids_json
     * @returns {Promise<void>}
     */
    static remove_confirmed_pending_changes(data, ids_json) {
        _assertClass(data, SafeData);
        const ptr0 = passStringToWasm0(ids_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.datamanager_remove_confirmed_pending_changes(data.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * Save the database to the backend and then pull the latest copy to re-sync
     * @param {SafeData} safe_data
     * @param {WrappedApiClient} api_client
     * @param {string} workspace_id
     * @param {string} token
     * @returns {Promise<void>}
     */
    static save(safe_data, api_client, workspace_id, token) {
        _assertClass(safe_data, SafeData);
        _assertClass(api_client, WrappedApiClient);
        const ptr0 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.datamanager_save(safe_data.__wbg_ptr, api_client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {Function} callback
     * @returns {Promise<void>}
     */
    static select_database(data, callback) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_select_database(data.__wbg_ptr, callback);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {Function} callback
     * @returns {Promise<void>}
     */
    static select_dependency_graph(data, callback) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_select_dependency_graph(data.__wbg_ptr, callback);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {Function} callback
     * @returns {Promise<void>}
     */
    static select_online_status(data, callback) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_select_online_status(data.__wbg_ptr, callback);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {Function} callback
     * @returns {Promise<void>}
     */
    static select_pending_changes(data, callback) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_select_pending_changes(data.__wbg_ptr, callback);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {Function} callback
     * @returns {Promise<void>}
     */
    static select_priority_graph(data, callback) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_select_priority_graph(data.__wbg_ptr, callback);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {Function} callback
     * @returns {Promise<void>}
     */
    static select_schedule(data, callback) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_select_schedule(data.__wbg_ptr, callback);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @param {BuildScheduleOptions} options
     * @returns {Promise<void>}
     */
    static set_schedule_options(data, client, token, workspace_id, options) {
        _assertClass(data, SafeData);
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.datamanager_set_schedule_options(data.__wbg_ptr, client.__wbg_ptr, ptr0, len0, ptr1, len1, options);
        return ret;
    }
    /**
     * Sync the resolved template cache from the JS-side TemplateCacheProvider.
     * This triggers a fuzzy schedule rebuild and notifies schedule subscribers.
     * @param {SafeData} data
     * @param {WrappedTemplateCache} template_cache
     * @returns {Promise<void>}
     */
    static sync_template_cache(data, template_cache) {
        _assertClass(data, SafeData);
        _assertClass(template_cache, WrappedTemplateCache);
        const ret = wasm.datamanager_sync_template_cache(data.__wbg_ptr, template_cache.__wbg_ptr);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {number} index
     * @returns {Promise<void>}
     */
    static undo_pending_change(data, index) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_undo_pending_change(data.__wbg_ptr, index);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @returns {Promise<void>}
     */
    static undo_pending_changes(data) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_undo_pending_changes(data.__wbg_ptr);
        return ret;
    }
    /**
     * @param {SafeData} data
     * @param {Function} callback
     * @returns {Promise<void>}
     */
    static unsubscribe(data, callback) {
        _assertClass(data, SafeData);
        const ret = wasm.datamanager_unsubscribe(data.__wbg_ptr, callback);
        return ret;
    }
}
if (Symbol.dispose) DataManager.prototype[Symbol.dispose] = DataManager.prototype.free;

export class DatabaseCache {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DatabaseCacheFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_databasecache_free(ptr, 0);
    }
}
if (Symbol.dispose) DatabaseCache.prototype[Symbol.dispose] = DatabaseCache.prototype.free;

export class DecisionWithAssociatedData {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DecisionWithAssociatedData.prototype);
        obj.__wbg_ptr = ptr;
        DecisionWithAssociatedDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DecisionWithAssociatedDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_decisionwithassociateddata_free(ptr, 0);
    }
    /**
     * @returns {WrappedDecisionNode}
     */
    decision() {
        const ret = wasm.decisionwithassociateddata_decision(this.__wbg_ptr);
        return WrappedDecisionNode.__wrap(ret);
    }
}
if (Symbol.dispose) DecisionWithAssociatedData.prototype[Symbol.dispose] = DecisionWithAssociatedData.prototype.free;

export class DependencyWithAssociatedData {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DependencyWithAssociatedData.prototype);
        obj.__wbg_ptr = ptr;
        DependencyWithAssociatedDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DependencyWithAssociatedDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_dependencywithassociateddata_free(ptr, 0);
    }
    /**
     * @returns {WrappedDependency}
     */
    dependency() {
        const ret = wasm.dependencywithassociateddata_dependency(this.__wbg_ptr);
        return WrappedDependency.__wrap(ret);
    }
    /**
     * @returns {WrappedProduct | undefined}
     */
    project() {
        const ret = wasm.dependencywithassociateddata_project(this.__wbg_ptr);
        return ret === 0 ? undefined : WrappedProduct.__wrap(ret);
    }
}
if (Symbol.dispose) DependencyWithAssociatedData.prototype[Symbol.dispose] = DependencyWithAssociatedData.prototype.free;

export class OutcomeWithAssociatedData {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OutcomeWithAssociatedData.prototype);
        obj.__wbg_ptr = ptr;
        OutcomeWithAssociatedDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OutcomeWithAssociatedDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_outcomewithassociateddata_free(ptr, 0);
    }
    /**
     * @returns {WrappedOutcome}
     */
    outcome() {
        const ret = wasm.outcomewithassociateddata_outcome(this.__wbg_ptr);
        return WrappedOutcome.__wrap(ret);
    }
    /**
     * @returns {WrappedProduct | undefined}
     */
    project() {
        const ret = wasm.outcomewithassociateddata_project(this.__wbg_ptr);
        return ret === 0 ? undefined : WrappedProduct.__wrap(ret);
    }
}
if (Symbol.dispose) OutcomeWithAssociatedData.prototype[Symbol.dispose] = OutcomeWithAssociatedData.prototype.free;

export class PersonWithAssociatedData {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PersonWithAssociatedData.prototype);
        obj.__wbg_ptr = ptr;
        PersonWithAssociatedDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PersonWithAssociatedDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_personwithassociateddata_free(ptr, 0);
    }
    /**
     * @returns {WrappedPerson}
     */
    person() {
        const ret = wasm.personwithassociateddata_person(this.__wbg_ptr);
        return WrappedPerson.__wrap(ret);
    }
}
if (Symbol.dispose) PersonWithAssociatedData.prototype[Symbol.dispose] = PersonWithAssociatedData.prototype.free;

export class PrioritySearchResultItem {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PrioritySearchResultItem.prototype);
        obj.__wbg_ptr = ptr;
        PrioritySearchResultItemFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PrioritySearchResultItemFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_prioritysearchresultitem_free(ptr, 0);
    }
    /**
     * @returns {string | undefined}
     */
    description() {
        const ret = wasm.prioritysearchresultitem_description(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * Returns the NodeId as { type_: string, id: string } for use in AddPriorityItem commands.
     * @returns {any}
     */
    entity_node_id() {
        const ret = wasm.prioritysearchresultitem_entity_node_id(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {NodeMatcher}
     */
    id() {
        const ret = wasm.prioritysearchresultitem_id(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {WrappedProduct | undefined}
     */
    project() {
        const ret = wasm.prioritysearchresultitem_project(this.__wbg_ptr);
        return ret === 0 ? undefined : WrappedProduct.__wrap(ret);
    }
    /**
     * @returns {string}
     */
    title() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.prioritysearchresultitem_title(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) PrioritySearchResultItem.prototype[Symbol.dispose] = PrioritySearchResultItem.prototype.free;

export class ProjectWithAssociatedData {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ProjectWithAssociatedData.prototype);
        obj.__wbg_ptr = ptr;
        ProjectWithAssociatedDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProjectWithAssociatedDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_projectwithassociateddata_free(ptr, 0);
    }
    /**
     * @returns {WrappedProduct}
     */
    project() {
        const ret = wasm.projectwithassociateddata_project(this.__wbg_ptr);
        return WrappedProduct.__wrap(ret);
    }
}
if (Symbol.dispose) ProjectWithAssociatedData.prototype[Symbol.dispose] = ProjectWithAssociatedData.prototype.free;

/**
 * @enum {0 | 1}
 */
export const QuestionWhy = Object.freeze({
    /**
     * Combine disconnected components of the priority graph into one
     */
    MergePriorityGraph: 0, "0": "MergePriorityGraph",
    /**
     * Bring more nodes into the priority graph
     */
    ExtendPriorityGraph: 1, "1": "ExtendPriorityGraph",
});

export class SafeData {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SafeData.prototype);
        obj.__wbg_ptr = ptr;
        SafeDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SafeDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_safedata_free(ptr, 0);
    }
    /**
     * First attempt to load from storage. If that fails, then attempt to load from the remote API.
     * @param {WrappedApiClient} api_client
     * @param {string} workspace_id
     * @param {string} token
     * @returns {Promise<SafeData>}
     */
    static load(api_client, workspace_id, token) {
        _assertClass(api_client, WrappedApiClient);
        const ptr0 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.safedata_load(api_client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    constructor() {
        const ret = wasm.safedata_new();
        this.__wbg_ptr = ret >>> 0;
        SafeDataFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
}
if (Symbol.dispose) SafeData.prototype[Symbol.dispose] = SafeData.prototype.free;

export class StakeholderWithAssociatedData {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StakeholderWithAssociatedData.prototype);
        obj.__wbg_ptr = ptr;
        StakeholderWithAssociatedDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StakeholderWithAssociatedDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stakeholderwithassociateddata_free(ptr, 0);
    }
    /**
     * @returns {WrappedStakeholder}
     */
    stakeholder() {
        const ret = wasm.stakeholderwithassociateddata_stakeholder(this.__wbg_ptr);
        return WrappedStakeholder.__wrap(ret);
    }
}
if (Symbol.dispose) StakeholderWithAssociatedData.prototype[Symbol.dispose] = StakeholderWithAssociatedData.prototype.free;

export class TaskWithAssociatedData {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TaskWithAssociatedData.prototype);
        obj.__wbg_ptr = ptr;
        TaskWithAssociatedDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TaskWithAssociatedDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_taskwithassociateddata_free(ptr, 0);
    }
    /**
     * @returns {WrappedProduct | undefined}
     */
    project() {
        const ret = wasm.taskwithassociateddata_project(this.__wbg_ptr);
        return ret === 0 ? undefined : WrappedProduct.__wrap(ret);
    }
    /**
     * @returns {WrappedTask}
     */
    task() {
        const ret = wasm.taskwithassociateddata_task(this.__wbg_ptr);
        return WrappedTask.__wrap(ret);
    }
}
if (Symbol.dispose) TaskWithAssociatedData.prototype[Symbol.dispose] = TaskWithAssociatedData.prototype.free;

export class TeamWithAssociatedData {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TeamWithAssociatedData.prototype);
        obj.__wbg_ptr = ptr;
        TeamWithAssociatedDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TeamWithAssociatedDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_teamwithassociateddata_free(ptr, 0);
    }
    /**
     * @returns {WrappedTeam}
     */
    team() {
        const ret = wasm.teamwithassociateddata_team(this.__wbg_ptr);
        return WrappedTeam.__wrap(ret);
    }
}
if (Symbol.dispose) TeamWithAssociatedData.prototype[Symbol.dispose] = TeamWithAssociatedData.prototype.free;

export class WorkflowInstanceWithAssociatedData {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WorkflowInstanceWithAssociatedData.prototype);
        obj.__wbg_ptr = ptr;
        WorkflowInstanceWithAssociatedDataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WorkflowInstanceWithAssociatedDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_workflowinstancewithassociateddata_free(ptr, 0);
    }
    /**
     * @returns {WrappedWorkflowInstance}
     */
    instance() {
        const ret = wasm.workflowinstancewithassociateddata_instance(this.__wbg_ptr);
        return WrappedWorkflowInstance.__wrap(ret);
    }
}
if (Symbol.dispose) WorkflowInstanceWithAssociatedData.prototype[Symbol.dispose] = WorkflowInstanceWithAssociatedData.prototype.free;

export class WrappedApiClient {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedApiClientFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedapiclient_free(ptr, 0);
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {TokenAcceptInviteRequest} request
     * @returns {Promise<TokenAcceptInviteResponse>}
     */
    static accept_invite(client, token, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_accept_invite(client.__wbg_ptr, ptr0, len0, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workflow_id
     * @param {BatchCreateWorkflowEventsRequest} request
     * @returns {Promise<BatchCreateWorkflowEventsResponse>}
     */
    static batch_create_workflow_events(client, token, workflow_id, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workflow_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_batch_create_workflow_events(client.__wbg_ptr, ptr0, len0, ptr1, len1, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} template_id
     * @param {BatchCreateWorkflowTemplateEventsRequest} request
     * @returns {Promise<BatchCreateWorkflowTemplateEventsResponse>}
     */
    static batch_create_workflow_template_events(client, token, template_id, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(template_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_batch_create_workflow_template_events(client.__wbg_ptr, ptr0, len0, ptr1, len1, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {CreateTokenRequest} request
     * @returns {Promise<Token>}
     */
    static create_token(client, token, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_create_token(client.__wbg_ptr, ptr0, len0, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workflow_id
     * @param {CreateWorkflowEventRequest} request
     * @returns {Promise<WorkflowEvent>}
     */
    static create_workflow_event(client, token, workflow_id, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workflow_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_create_workflow_event(client.__wbg_ptr, ptr0, len0, ptr1, len1, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} template_id
     * @param {CreateWorkflowRequest} request
     * @returns {Promise<Workflow>}
     */
    static create_workflow_from_template(client, token, template_id, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(template_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_create_workflow_from_template(client.__wbg_ptr, ptr0, len0, ptr1, len1, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} template_id
     * @param {CreateWorkflowTemplateEventRequest} request
     * @returns {Promise<WorkflowTemplateEvent>}
     */
    static create_workflow_template_event(client, token, template_id, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(template_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_create_workflow_template_event(client.__wbg_ptr, ptr0, len0, ptr1, len1, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {CreateWorkspaceRequest} request
     * @returns {Promise<Workspace>}
     */
    static create_workspace(client, token, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_create_workspace(client.__wbg_ptr, ptr0, len0, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} workspace_id
     * @param {string} token
     * @param {CreateDataSourceRequest} request
     * @returns {Promise<WorkspaceDataSource>}
     */
    static create_workspace_data_source(client, workspace_id, token, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_create_workspace_data_source(client.__wbg_ptr, ptr0, len0, ptr1, len1, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @param {CreateWorkflowTemplateRequest} request
     * @returns {Promise<WorkflowTemplate>}
     */
    static create_workspace_workflow_template(client, token, workspace_id, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_create_workspace_workflow_template(client.__wbg_ptr, ptr0, len0, ptr1, len1, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workflow_id
     * @returns {Promise<void>}
     */
    static delete_workflow(client, token, workflow_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workflow_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_delete_workflow(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} template_id
     * @returns {Promise<void>}
     */
    static delete_workflow_template(client, token, template_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(template_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_delete_workflow_template(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @param {string} data_source_id
     * @returns {Promise<void>}
     */
    static delete_workspace_data_source(client, token, workspace_id, data_source_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(data_source_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_delete_workspace_data_source(client.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @param {string} token_id
     * @returns {Promise<void>}
     */
    static delete_workspace_token(client, token, workspace_id, token_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(token_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_delete_workspace_token(client.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} user_id
     * @returns {Promise<UserProfile>}
     */
    static get_user_profile(client, token, user_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_get_user_profile(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workflow_id
     * @returns {Promise<Workflow>}
     */
    static get_workflow(client, token, workflow_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workflow_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_get_workflow(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} template_id
     * @returns {Promise<WorkflowTemplate>}
     */
    static get_workflow_template(client, token, template_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(template_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_get_workflow_template(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @returns {Promise<Workspace>}
     */
    static get_workspace(client, token, workspace_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_get_workspace(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @returns {Promise<BuildScheduleOptions>}
     */
    static get_workspace_build_schedule_options(client, token, workspace_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_get_workspace_build_schedule_options(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} template_id
     * @returns {Promise<ListWorkflowsResponse>}
     */
    static list_template_workflows(client, token, template_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(template_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_template_workflows(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @returns {Promise<ListUserProfilesResponse>}
     */
    static list_user_profiles(client, token) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_user_profiles(client.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @returns {Promise<any>}
     */
    static list_viewer_workspace_authorizations(client, token) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_viewer_workspace_authorizations(client.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @returns {Promise<any>}
     */
    static list_viewer_workspaces(client, token) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_viewer_workspaces(client.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workflow_id
     * @returns {Promise<ListWorkflowEventsResponse>}
     */
    static list_workflow_events(client, token, workflow_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workflow_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_workflow_events(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} template_id
     * @returns {Promise<ListWorkflowTemplateEventsResponse>}
     */
    static list_workflow_template_events(client, token, template_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(template_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_workflow_template_events(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} workspace_id
     * @param {string} token
     * @returns {Promise<{ data_sources: WorkspaceDataSource[] }>}
     */
    static list_workspace_data_sources(client, workspace_id, token) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_workspace_data_sources(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @param {PaginationRequestQueryParameters} query
     * @returns {Promise<Paginated>}
     */
    static list_workspace_events(client, token, workspace_id, query) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_workspace_events(client.__wbg_ptr, ptr0, len0, ptr1, len1, query);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @returns {Promise<ListWorkspaceTokensResponse>}
     */
    static list_workspace_tokens(client, token, workspace_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_workspace_tokens(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @returns {Promise<ListUserProfilesResponse>}
     */
    static list_workspace_user_profiles(client, token, workspace_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_workspace_user_profiles(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @returns {Promise<ListWorkflowTemplatesResponse>}
     */
    static list_workspace_workflow_templates(client, token, workspace_id) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_list_workspace_workflow_templates(client.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @param {string} base_url
     */
    constructor(base_url) {
        const ptr0 = passStringToWasm0(base_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_new(ptr0, len0);
        this.__wbg_ptr = ret >>> 0;
        WrappedApiClientFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workspace_id
     * @param {UpdateBuildScheduleOptionsRequest} options
     * @returns {Promise<UpdateBuildScheduleOptionsResponse>}
     */
    static update_build_schedule_options(client, token, workspace_id, options) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_update_build_schedule_options(client.__wbg_ptr, ptr0, len0, ptr1, len1, options);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} user_id
     * @param {UpdateUserProfileRequest} profile
     * @returns {Promise<UserProfile>}
     */
    static update_user_profile(client, token, user_id, profile) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_update_user_profile(client.__wbg_ptr, ptr0, len0, ptr1, len1, profile);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} workflow_id
     * @param {UpdateWorkflowRequest} request
     * @returns {Promise<Workflow>}
     */
    static update_workflow(client, token, workflow_id, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(workflow_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_update_workflow(client.__wbg_ptr, ptr0, len0, ptr1, len1, request);
        return ret;
    }
    /**
     * @param {WrappedApiClient} client
     * @param {string} token
     * @param {string} template_id
     * @param {UpdateWorkflowTemplateRequest} request
     * @returns {Promise<WorkflowTemplate>}
     */
    static update_workflow_template(client, token, template_id, request) {
        _assertClass(client, WrappedApiClient);
        const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(template_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappedapiclient_update_workflow_template(client.__wbg_ptr, ptr0, len0, ptr1, len1, request);
        return ret;
    }
}
if (Symbol.dispose) WrappedApiClient.prototype[Symbol.dispose] = WrappedApiClient.prototype.free;

export class WrappedConsolidationAnalysis {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedConsolidationAnalysis.prototype);
        obj.__wbg_ptr = ptr;
        WrappedConsolidationAnalysisFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedConsolidationAnalysisFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedconsolidationanalysis_free(ptr, 0);
    }
    /**
     * @param {Answer} answer
     * @returns {Promise<DatabaseCommand | undefined>}
     */
    apply_answer(answer) {
        const ret = wasm.wrappedconsolidationanalysis_apply_answer(this.__wbg_ptr, answer);
        return ret;
    }
    /**
     * @param {SafeData} safe_data
     * @returns {Promise<Question | undefined>}
     */
    get_next_question(safe_data) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappedconsolidationanalysis_get_next_question(this.__wbg_ptr, safe_data.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) WrappedConsolidationAnalysis.prototype[Symbol.dispose] = WrappedConsolidationAnalysis.prototype.free;

/**
 * We wrap the database so that it doesn't have to be completely serialized each time it's passed into JS (wildly inefficient).
 *
 * This lets us mask the inner data behind getters so that the JS app can just request the data it needs.
 */
export class WrappedDatabase {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedDatabase.prototype);
        obj.__wbg_ptr = ptr;
        WrappedDatabaseFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedDatabaseFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappeddatabase_free(ptr, 0);
    }
    /**
     * Check which of a task's requirements are unsatisfied by existing
     * resource reservations during the given window. Used by the planner UI to
     * warn when scheduled work lacks its required resources, and to drive
     * "reserve one of these" helpers.
     * @param {string} task_id
     * @param {string} window_start
     * @param {string} window_end
     * @returns {any}
     */
    check_task_requirements(task_id, window_start, window_end) {
        const ptr0 = passStringToWasm0(task_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(window_start, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passStringToWasm0(window_end, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.wrappeddatabase_check_task_requirements(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedDecisionNode>}
     */
    decisions() {
        const ret = wasm.wrappeddatabase_decisions(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {PersonAvailability[]}
     */
    default_availability() {
        const ret = wasm.wrappeddatabase_default_availability(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Dependency[]}
     */
    dependencies() {
        const ret = wasm.wrappeddatabase_dependencies(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Get manual resource allocations for a schedulable entity (task or workflow step).
     * `entity_key` is either a bare UUID (task) or "step:{instance_id}:{step_id}".
     * @param {string} entity_key
     * @returns {any}
     */
    manual_allocations_for(entity_key) {
        const ptr0 = passStringToWasm0(entity_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappeddatabase_manual_allocations_for(this.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * Get all manual resource allocations for a specific person across all entities.
     * Returns a JSON array of `{ entity: string, allocation: ManualResourceAllocation }`.
     * @param {string} person_id
     * @returns {any}
     */
    manual_allocations_for_person(person_id) {
        const ptr0 = passStringToWasm0(person_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappeddatabase_manual_allocations_for_person(this.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedOutcome>}
     */
    outcomes() {
        const ret = wasm.wrappeddatabase_outcomes(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedPerson>}
     */
    people() {
        const ret = wasm.wrappeddatabase_people(this.__wbg_ptr);
        return ret;
    }
    /**
     * Get all priority item owners as a list of NodeIds that have priority lists.
     * @returns {any}
     */
    priority_item_owners() {
        const ret = wasm.wrappeddatabase_priority_item_owners(this.__wbg_ptr);
        return ret;
    }
    /**
     * Get priority items for a specific owner (team or person).
     * `owner_type` is e.g. "Team" or "Person", `owner_id` is the BaseNodeId UUID string.
     * @param {string} owner_type
     * @param {string} owner_id
     * @returns {any}
     */
    priority_items_for_owner(owner_type, owner_id) {
        const ptr0 = passStringToWasm0(owner_type, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(owner_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wrappeddatabase_priority_items_for_owner(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedProblem>}
     */
    problems() {
        const ret = wasm.wrappeddatabase_problems(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedProject>}
     */
    projects() {
        const ret = wasm.wrappeddatabase_projects(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {string} stakeholder_id
     * @returns {string[]}
     */
    representatives_for_stakeholder(stakeholder_id) {
        const ptr0 = passStringToWasm0(stakeholder_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappeddatabase_representatives_for_stakeholder(this.__wbg_ptr, ptr0, len0);
        var v2 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v2;
    }
    /**
     * @returns {WrappedRequirement[]}
     */
    requirements() {
        const ret = wasm.wrappeddatabase_requirements(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedResourceGroup>}
     */
    resource_groups() {
        const ret = wasm.wrappeddatabase_resource_groups(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedResourceReservation>}
     */
    resource_reservations() {
        const ret = wasm.wrappeddatabase_resource_reservations(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedResource>}
     */
    resources() {
        const ret = wasm.wrappeddatabase_resources(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedStakeholder>}
     */
    stakeholders() {
        const ret = wasm.wrappeddatabase_stakeholders(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedTask>}
     */
    tasks() {
        const ret = wasm.wrappeddatabase_tasks(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Record<string, WrappedTeam>}
     */
    teams() {
        const ret = wasm.wrappeddatabase_teams(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {StakeholderValueAllocation[]}
     */
    value_allocations() {
        const ret = wasm.wrappeddatabase_value_allocations(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {string} stakeholder_id
     * @returns {StakeholderValueAllocation[]}
     */
    value_allocations_for_stakeholder(stakeholder_id) {
        const ptr0 = passStringToWasm0(stakeholder_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappeddatabase_value_allocations_for_stakeholder(this.__wbg_ptr, ptr0, len0);
        var v2 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v2;
    }
    /**
     * @returns {Record<string, WrappedWorkflowInstance>}
     */
    workflow_instances() {
        const ret = wasm.wrappeddatabase_workflow_instances(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) WrappedDatabase.prototype[Symbol.dispose] = WrappedDatabase.prototype.free;

export class WrappedDecisionNode {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedDecisionNode.prototype);
        obj.__wbg_ptr = ptr;
        WrappedDecisionNodeFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedDecisionNodeFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappeddecisionnode_free(ptr, 0);
    }
    /**
     * @returns {string[]}
     */
    choices() {
        const ret = wasm.wrappeddecisionnode_choices(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {boolean}
     */
    exclusive() {
        const ret = wasm.wrappeddecisionnode_exclusive(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappeddecisionnode_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    title() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappeddecisionnode_title(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) WrappedDecisionNode.prototype[Symbol.dispose] = WrappedDecisionNode.prototype.free;

export class WrappedDependency {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedDependency.prototype);
        obj.__wbg_ptr = ptr;
        WrappedDependencyFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedDependencyFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappeddependency_free(ptr, 0);
    }
    /**
     * @returns {WrappedDecisionNode | undefined}
     */
    as_decision() {
        const ret = wasm.wrappeddependency_as_decision(this.__wbg_ptr);
        return ret === 0 ? undefined : WrappedDecisionNode.__wrap(ret);
    }
    /**
     * @returns {WrappedOutcome | undefined}
     */
    as_outcome() {
        const ret = wasm.wrappeddependency_as_outcome(this.__wbg_ptr);
        return ret === 0 ? undefined : WrappedOutcome.__wrap(ret);
    }
    /**
     * @returns {WrappedTask | undefined}
     */
    as_task() {
        const ret = wasm.wrappeddependency_as_task(this.__wbg_ptr);
        return ret === 0 ? undefined : WrappedTask.__wrap(ret);
    }
    /**
     * @returns {WrappedWorkflowInstance | undefined}
     */
    as_workflow_instance() {
        const ret = wasm.wrappeddependency_as_workflow_instance(this.__wbg_ptr);
        return ret === 0 ? undefined : WrappedWorkflowInstance.__wrap(ret);
    }
}
if (Symbol.dispose) WrappedDependency.prototype[Symbol.dispose] = WrappedDependency.prototype.free;

export class WrappedDependencyGraph {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedDependencyGraph.prototype);
        obj.__wbg_ptr = ptr;
        WrappedDependencyGraphFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedDependencyGraphFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappeddependencygraph_free(ptr, 0);
    }
    /**
     * @param {DependencyNodeId} node_id
     * @returns {DependencyNodeId[]}
     */
    get_deep_dependencies(node_id) {
        const ret = wasm.wrappeddependencygraph_get_deep_dependencies(this.__wbg_ptr, node_id);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {DependencyNodeId} node_id
     * @returns {DependencyNodeId[]}
     */
    get_deep_dependents(node_id) {
        const ret = wasm.wrappeddependencygraph_get_deep_dependents(this.__wbg_ptr, node_id);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {DependencyNodeId} node_id
     * @returns {DependencyNodeId[]}
     */
    get_dependencies(node_id) {
        const ret = wasm.wrappeddependencygraph_get_dependencies(this.__wbg_ptr, node_id);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {DependencyNodeId} node_id
     * @returns {DependencyNodeId[]}
     */
    get_dependents(node_id) {
        const ret = wasm.wrappeddependencygraph_get_dependents(this.__wbg_ptr, node_id);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * For each node in `node_ids`, return its list of incomplete direct blockers.
     * Returns a JSON object: `{ [nodeId: string]: Array<{ id: DependencyNodeId, title: string }> }`.
     * Nodes with no incomplete blockers get an empty array (i.e. they are eligible).
     * @param {WrappedDatabase} database
     * @param {DependencyNodeId[]} node_ids
     * @returns {any}
     */
    incomplete_blockers_for_nodes(database, node_ids) {
        _assertClass(database, WrappedDatabase);
        const ptr0 = passArrayJsValueToWasm0(node_ids, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wrappeddependencygraph_incomplete_blockers_for_nodes(this.__wbg_ptr, database.__wbg_ptr, ptr0, len0);
        return ret;
    }
}
if (Symbol.dispose) WrappedDependencyGraph.prototype[Symbol.dispose] = WrappedDependencyGraph.prototype.free;

export class WrappedEpoch {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedEpoch.prototype);
        obj.__wbg_ptr = ptr;
        WrappedEpochFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedEpochFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedepoch_free(ptr, 0);
    }
    /**
     * @returns {Date}
     */
    end_date() {
        const ret = wasm.wrappedepoch_end_date(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {SchedulingEpoch}
     */
    inner() {
        const ret = wasm.wrappedepoch_inner(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Date}
     */
    start_date() {
        const ret = wasm.wrappedepoch_start_date(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) WrappedEpoch.prototype[Symbol.dispose] = WrappedEpoch.prototype.free;

export class WrappedNodeMatcher {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedNodeMatcherFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappednodematcher_free(ptr, 0);
    }
    /**
     * Don't call this in an iterator - it'll lock things up because it's slow!
     * If that's necessary add a new method to call it in batch
     * @param {SafeData} safe_data
     * @returns {Promise<string>}
     */
    label(safe_data) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappednodematcher_label(this.__wbg_ptr, safe_data.__wbg_ptr);
        return ret;
    }
    /**
     * @param {NodeMatcher} matcher
     */
    constructor(matcher) {
        const ret = wasm.wrappednodematcher_new(matcher);
        this.__wbg_ptr = ret >>> 0;
        WrappedNodeMatcherFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
}
if (Symbol.dispose) WrappedNodeMatcher.prototype[Symbol.dispose] = WrappedNodeMatcher.prototype.free;

export class WrappedOutcome {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedOutcome.prototype);
        obj.__wbg_ptr = ptr;
        WrappedOutcomeFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedOutcomeFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedoutcome_free(ptr, 0);
    }
    /**
     * @returns {CompletionCriterion}
     */
    completion_criterion() {
        const ret = wasm.wrappedoutcome_completion_criterion(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Deadline[]}
     */
    deadlines() {
        const ret = wasm.wrappedoutcome_deadlines(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {string | undefined}
     */
    description() {
        const ret = wasm.wrappedoutcome_description(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedoutcome_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {RemoteReference | undefined}
     */
    remote_reference() {
        const ret = wasm.wrappedoutcome_remote_reference(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    title() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedoutcome_title(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) WrappedOutcome.prototype[Symbol.dispose] = WrappedOutcome.prototype.free;

export class WrappedPerson {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedPerson.prototype);
        obj.__wbg_ptr = ptr;
        WrappedPersonFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedPersonFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedperson_free(ptr, 0);
    }
    /**
     * @returns {PersonAvailability[]}
     */
    availability() {
        const ret = wasm.wrappedperson_availability(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {string | undefined}
     */
    avatar_url() {
        const ret = wasm.wrappedperson_avatar_url(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedperson_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedperson_name(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Promise<RemoteReference[]>}
     */
    remote_references() {
        const ret = wasm.wrappedperson_remote_references(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {SafeData} safe_data
     * @returns {Promise<string[]>}
     */
    team_ids(safe_data) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappedperson_team_ids(this.__wbg_ptr, safe_data.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) WrappedPerson.prototype[Symbol.dispose] = WrappedPerson.prototype.free;

export class WrappedPriorityGraph {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedPriorityGraph.prototype);
        obj.__wbg_ptr = ptr;
        WrappedPriorityGraphFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedPriorityGraphFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedprioritygraph_free(ptr, 0);
    }
    /**
     * @param {NodeMatcher} node_matcher
     * @returns {PriorityGraphNeighbors}
     */
    get_neighbors(node_matcher) {
        const ret = wasm.wrappedprioritygraph_get_neighbors(this.__wbg_ptr, node_matcher);
        return ret;
    }
    /**
     * @returns {NodeMatcherWithScore[]}
     */
    get_nodes_with_scores() {
        const ret = wasm.wrappedprioritygraph_get_nodes_with_scores(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) WrappedPriorityGraph.prototype[Symbol.dispose] = WrappedPriorityGraph.prototype.free;

export class WrappedProblem {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedProblem.prototype);
        obj.__wbg_ptr = ptr;
        WrappedProblemFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedProblemFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedproblem_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    created_at() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedproblem_created_at(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */
    description() {
        const ret = wasm.wrappedproblem_description(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedproblem_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */
    reported_by() {
        const ret = wasm.wrappedproblem_reported_by(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {boolean}
     */
    resolved() {
        const ret = wasm.wrappedproblem_resolved(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string | undefined}
     */
    resolved_at() {
        const ret = wasm.wrappedproblem_resolved_at(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string}
     */
    title() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedproblem_title(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    updated_at() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedproblem_updated_at(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) WrappedProblem.prototype[Symbol.dispose] = WrappedProblem.prototype.free;

export class WrappedProduct {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedProduct.prototype);
        obj.__wbg_ptr = ptr;
        WrappedProductFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedProductFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedproduct_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    created_at() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedproduct_created_at(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */
    description() {
        const ret = wasm.wrappedproduct_description(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {boolean}
     */
    draft() {
        const ret = wasm.wrappedproduct_draft(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedproduct_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */
    lifecycle_stage() {
        const ret = wasm.wrappedproduct_lifecycle_stage(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string}
     */
    name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedproduct_name(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {RemoteReference | undefined}
     */
    remote_reference() {
        const ret = wasm.wrappedproduct_remote_reference(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) WrappedProduct.prototype[Symbol.dispose] = WrappedProduct.prototype.free;

export class WrappedRequirement {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedRequirement.prototype);
        obj.__wbg_ptr = ptr;
        WrappedRequirementFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedRequirementFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedrequirement_free(ptr, 0);
    }
    /**
     * @returns {any}
     */
    metadata() {
        const ret = wasm.wrappedrequirement_metadata(this.__wbg_ptr);
        return ret;
    }
    /**
     * NodeMatcher (scope) — which tasks/matchers this applies to.
     * @returns {any}
     */
    scope() {
        const ret = wasm.wrappedrequirement_scope(this.__wbg_ptr);
        return ret;
    }
    /**
     * ResourceMatcher (target) — which resource / group satisfies this.
     * @returns {any}
     */
    target() {
        const ret = wasm.wrappedrequirement_target(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) WrappedRequirement.prototype[Symbol.dispose] = WrappedRequirement.prototype.free;

export class WrappedResource {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedResource.prototype);
        obj.__wbg_ptr = ptr;
        WrappedResourceFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedResourceFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedresource_free(ptr, 0);
    }
    /**
     * `None` = unlimited. `Some(1)` = strictly exclusive.
     * @returns {number | undefined}
     */
    concurrency_limit() {
        const ret = wasm.wrappedresource_concurrency_limit(this.__wbg_ptr);
        return ret === 0x100000001 ? undefined : ret;
    }
    /**
     * @returns {number | undefined}
     */
    cooldown_days() {
        const ret = wasm.wrappedresource_cooldown_days(this.__wbg_ptr);
        return ret === 0x100000001 ? undefined : ret;
    }
    /**
     * @returns {string | undefined}
     */
    description() {
        const ret = wasm.wrappedresource_description(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * All groups this resource belongs to, directly or via nested groups.
     * @param {SafeData} safe_data
     * @param {boolean} include_ancestor_groups
     * @returns {Promise<string[]>}
     */
    group_ids(safe_data, include_ancestor_groups) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappedresource_group_ids(this.__wbg_ptr, safe_data.__wbg_ptr, include_ancestor_groups);
        return ret;
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedresource_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */
    managed_by_team_id() {
        const ret = wasm.wrappedresource_managed_by_team_id(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string}
     */
    name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedresource_name(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) WrappedResource.prototype[Symbol.dispose] = WrappedResource.prototype.free;

export class WrappedResourceAllocation {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedResourceAllocationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedresourceallocation_free(ptr, 0);
    }
    /**
     * @returns {boolean}
     */
    completes_task() {
        const ret = wasm.wrappedresourceallocation_completes_task(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string | undefined}
     */
    id() {
        const ret = wasm.wrappedresourceallocation_id(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string}
     */
    person_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedresourceallocation_person_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {ResourceAllocationSource}
     */
    source() {
        const ret = wasm.wrappedresourceallocation_source(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    task_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedresourceallocation_task_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    time() {
        const ret = wasm.wrappedresourceallocation_time(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {WrappedEpoch}
     */
    when() {
        const ret = wasm.wrappedresourceallocation_when(this.__wbg_ptr);
        return WrappedEpoch.__wrap(ret);
    }
}
if (Symbol.dispose) WrappedResourceAllocation.prototype[Symbol.dispose] = WrappedResourceAllocation.prototype.free;

export class WrappedResourceGroup {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedResourceGroup.prototype);
        obj.__wbg_ptr = ptr;
        WrappedResourceGroupFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedResourceGroupFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedresourcegroup_free(ptr, 0);
    }
    /**
     * All resources directly or transitively in this group.
     * @param {SafeData} safe_data
     * @returns {Promise<string[]>}
     */
    all_resource_ids(safe_data) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappedresourcegroup_all_resource_ids(this.__wbg_ptr, safe_data.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedresourcegroup_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */
    managed_by_team_id() {
        const ret = wasm.wrappedresourcegroup_managed_by_team_id(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * Direct sub-group memberships.
     * @param {SafeData} safe_data
     * @returns {Promise<string[]>}
     */
    member_group_ids(safe_data) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappedresourcegroup_member_group_ids(this.__wbg_ptr, safe_data.__wbg_ptr);
        return ret;
    }
    /**
     * Direct resource members of this group (no recursion through sub-groups).
     * @param {SafeData} safe_data
     * @returns {Promise<string[]>}
     */
    member_resource_ids(safe_data) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappedresourcegroup_member_resource_ids(this.__wbg_ptr, safe_data.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedresourcegroup_name(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) WrappedResourceGroup.prototype[Symbol.dispose] = WrappedResourceGroup.prototype.free;

export class WrappedResourceReservation {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedResourceReservation.prototype);
        obj.__wbg_ptr = ptr;
        WrappedResourceReservationFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedResourceReservationFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedresourcereservation_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedresourcereservation_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * True if this is a "block" (no target — the resource is unavailable).
     * @returns {boolean}
     */
    is_block() {
        const ret = wasm.wrappedresourcereservation_is_block(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * The NodeMatcher this reservation is for, or `null` if the resource is
     * merely blocked during this window.
     * @returns {any}
     */
    object() {
        const ret = wasm.wrappedresourcereservation_object(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string | undefined}
     */
    remark() {
        const ret = wasm.wrappedresourcereservation_remark(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string | undefined}
     */
    reserved_by() {
        const ret = wasm.wrappedresourcereservation_reserved_by(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string}
     */
    resource_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedresourcereservation_resource_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {SchedulingEpoch}
     */
    when() {
        const ret = wasm.wrappedresourcereservation_when(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) WrappedResourceReservation.prototype[Symbol.dispose] = WrappedResourceReservation.prototype.free;

export class WrappedStakeholder {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedStakeholder.prototype);
        obj.__wbg_ptr = ptr;
        WrappedStakeholderFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedStakeholderFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedstakeholder_free(ptr, 0);
    }
    /**
     * @returns {string | undefined}
     */
    description() {
        const ret = wasm.wrappedstakeholder_description(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedstakeholder_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedstakeholder_name(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) WrappedStakeholder.prototype[Symbol.dispose] = WrappedStakeholder.prototype.free;

export class WrappedTask {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedTask.prototype);
        obj.__wbg_ptr = ptr;
        WrappedTaskFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedTaskFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedtask_free(ptr, 0);
    }
    /**
     * @returns {boolean}
     */
    complete() {
        const ret = wasm.wrappedtask_complete(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {Deadline[]}
     */
    deadlines() {
        const ret = wasm.wrappedtask_deadlines(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {string | undefined}
     */
    description() {
        const ret = wasm.wrappedtask_description(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {WorkEstimate[]}
     */
    estimates() {
        const ret = wasm.wrappedtask_estimates(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedtask_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {SafeData} safe_data
     * @returns {Promise<WrappedProduct | undefined>}
     */
    project(safe_data) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappedtask_project(this.__wbg_ptr, safe_data.__wbg_ptr);
        return ret;
    }
    /**
     * @param {SafeData} safe_data
     * @returns {Promise<string | undefined>}
     */
    project_id(safe_data) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappedtask_project_id(this.__wbg_ptr, safe_data.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Promise<RemoteReference | undefined>}
     */
    reference() {
        const ret = wasm.wrappedtask_reference(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    title() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedtask_title(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) WrappedTask.prototype[Symbol.dispose] = WrappedTask.prototype.free;

export class WrappedTeam {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedTeam.prototype);
        obj.__wbg_ptr = ptr;
        WrappedTeamFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedTeamFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedteam_free(ptr, 0);
    }
    /**
     * @returns {PersonAvailability[]}
     */
    availability() {
        const ret = wasm.wrappedteam_availability(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedteam_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {SafeData} safe_data
     * @param {boolean} include_nested_teams
     * @returns {Promise<string[]>}
     */
    member_person_ids(safe_data, include_nested_teams) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappedteam_member_person_ids(this.__wbg_ptr, safe_data.__wbg_ptr, include_nested_teams);
        return ret;
    }
    /**
     * @param {SafeData} safe_data
     * @returns {Promise<string[]>}
     */
    member_team_ids(safe_data) {
        _assertClass(safe_data, SafeData);
        const ret = wasm.wrappedteam_member_team_ids(this.__wbg_ptr, safe_data.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedteam_name(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {any}
     */
    planning_rhythm() {
        const ret = wasm.wrappedteam_planning_rhythm(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) WrappedTeam.prototype[Symbol.dispose] = WrappedTeam.prototype.free;

/**
 * Opaque Rust-side cache of resolved workflow template states.
 *
 * The JS side builds `WorkflowTemplateState` from events via
 * `build_workflow_template_state`, then feeds it into this cache via `set()`.
 * The cache is passed to `build_database_fuzzy_schedule` so the database
 * adapter can resolve workflow instances against their templates without
 * re-crossing the WASM boundary.
 */
export class WrappedTemplateCache {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedTemplateCacheFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedtemplatecache_free(ptr, 0);
    }
    /**
     * Number of cached templates.
     * @returns {number}
     */
    len() {
        const ret = wasm.wrappedtemplatecache_len(this.__wbg_ptr);
        return ret >>> 0;
    }
    constructor() {
        const ret = wasm.wrappedtemplatecache_new();
        this.__wbg_ptr = ret >>> 0;
        WrappedTemplateCacheFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Remove a template from the cache.
     * @param {string} template_id
     */
    remove(template_id) {
        const ptr0 = passStringToWasm0(template_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.wrappedtemplatecache_remove(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Insert a resolved template state keyed by its template node ID.
     * @param {string} template_id
     * @param {WorkflowTemplateState} state
     */
    set(template_id, state) {
        const ptr0 = passStringToWasm0(template_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.wrappedtemplatecache_set(this.__wbg_ptr, ptr0, len0, state);
    }
}
if (Symbol.dispose) WrappedTemplateCache.prototype[Symbol.dispose] = WrappedTemplateCache.prototype.free;

export class WrappedWorkflowInstance {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WrappedWorkflowInstance.prototype);
        obj.__wbg_ptr = ptr;
        WrappedWorkflowInstanceFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WrappedWorkflowInstanceFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wrappedworkflowinstance_free(ptr, 0);
    }
    /**
     * @returns {string}
     */
    created_at() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedworkflowinstance_created_at(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedworkflowinstance_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    locked_version() {
        const ret = wasm.wrappedworkflowinstance_locked_version(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {any}
     */
    parameter_values() {
        const ret = wasm.wrappedworkflowinstance_parameter_values(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {any}
     */
    step_states() {
        const ret = wasm.wrappedworkflowinstance_step_states(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */
    template_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedworkflowinstance_template_id(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    title() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedworkflowinstance_title(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    title_template() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedworkflowinstance_title_template(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    version_preference() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.wrappedworkflowinstance_version_preference(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) WrappedWorkflowInstance.prototype[Symbol.dispose] = WrappedWorkflowInstance.prototype.free;

/**
 * Run Critical Path Method analysis on a workflow template.
 *
 * Returns a `CriticalPathResult` on success, or throws a JS error containing
 * a JSON array of `CriticalPathMissingEstimate` objects if any nodes lack
 * the required duration information.
 *
 * **Limitation:** CPM is a pure duration-and-dependency analysis. It does not
 * account for resource contention — two tasks sharing a worker but on parallel
 * branches will both appear independent even though the fuzzy scheduler would
 * serialize them.
 *
 * # Arguments
 * Same as `build_workflow_fuzzy_schedule`: the template, pool config, and
 * pre-decisions are used to construct the `ScheduleInput` graph.
 * @param {WorkflowTemplateState} template
 * @param {(Array<any>)[]} pool_config
 * @param {(Array<any>)[]} pre_decisions
 * @param {number | null} [units_per_day]
 * @returns {CriticalPathResult}
 */
export function analyze_workflow_critical_path(template, pool_config, pre_decisions, units_per_day) {
    const ptr0 = passArrayJsValueToWasm0(pool_config, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayJsValueToWasm0(pre_decisions, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.analyze_workflow_critical_path(template, ptr0, len0, ptr1, len1, !isLikeNone(units_per_day), isLikeNone(units_per_day) ? 0 : units_per_day);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Build a fuzzy (probabilistic) schedule for the entire database.
 *
 * This considers all prioritized entities: standalone tasks, decisions,
 * workflow instance steps (resolved against their templates), manual schedule
 * progress, dependency links, and resource assignments.
 *
 * # Arguments
 * - `database`: The full database state (WrappedDatabase).
 * - `template_cache`: Pre-resolved template states for workflow instances.
 * - `reference_date`: ISO date string (YYYY-MM-DD). Day 0 of the schedule.
 * - `resolution`: Time bucket size in days (default 0.5).
 * - `units_per_day`: Work units per resource per day (default 1.0).
 * @param {WrappedDatabase} database
 * @param {WrappedTemplateCache} template_cache
 * @param {string} reference_date
 * @param {number | null} [resolution]
 * @param {number | null} [units_per_day]
 * @returns {DatabaseFuzzyScheduleResult}
 */
export function build_database_fuzzy_schedule(database, template_cache, reference_date, resolution, units_per_day) {
    _assertClass(database, WrappedDatabase);
    _assertClass(template_cache, WrappedTemplateCache);
    const ptr0 = passStringToWasm0(reference_date, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.build_database_fuzzy_schedule(database.__wbg_ptr, template_cache.__wbg_ptr, ptr0, len0, !isLikeNone(resolution), isLikeNone(resolution) ? 0 : resolution, !isLikeNone(units_per_day), isLikeNone(units_per_day) ? 0 : units_per_day);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Build planning suggestions for a team over a date range.
 *
 * Returns a `PlanningGridResult` (serialized as JS object) containing
 * per-person, per-day cells with capacity, committed allocations,
 * draft allocations, and suggestions from the fuzzy scheduler.
 *
 * `rhythm` is optional — if null/undefined, resolves from team → workspace → default.
 * @param {WrappedDatabase} database
 * @param {WrappedTemplateCache} template_cache
 * @param {string} team_id
 * @param {string} start_date
 * @param {string} end_date
 * @param {any} rhythm
 * @param {DraftAllocationDto[]} draft_allocations
 * @returns {any}
 */
export function build_team_planning_suggestions(database, template_cache, team_id, start_date, end_date, rhythm, draft_allocations) {
    _assertClass(database, WrappedDatabase);
    _assertClass(template_cache, WrappedTemplateCache);
    const ptr0 = passStringToWasm0(team_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(start_date, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(end_date, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayJsValueToWasm0(draft_allocations, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.build_team_planning_suggestions(database.__wbg_ptr, template_cache.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, rhythm, ptr3, len3);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Build a fuzzy (probabilistic) schedule for a workflow template.
 *
 * # Arguments
 * - `template`: The rendered workflow template state.
 * - `pool_config`: Array of `[workMatcherLabel, workerCount]` pairs. Labels are strings
 *   like `"param:developer"`, `"everyone"`, `"team:abc"`. Unlisted pools default to 1 worker.
 * - `pre_decisions`: Array of `[stepUuid, [selectedBranchUuid, ...]]` pairs.
 *   Steps listed here are treated as pre-decided; unlisted branches auto-resolve with all options.
 * - `resolution`: Time bucket size in days (e.g., 0.5 for half-day). Smaller = more precise.
 * - `units_per_day`: How many work units each resource completes per day. Default 1.0.
 * @param {WorkflowTemplateState} template
 * @param {(Array<any>)[]} pool_config
 * @param {(Array<any>)[]} pre_decisions
 * @param {number | null} [resolution]
 * @param {number | null} [units_per_day]
 * @returns {FuzzyScheduleResult}
 */
export function build_workflow_fuzzy_schedule(template, pool_config, pre_decisions, resolution, units_per_day) {
    const ptr0 = passArrayJsValueToWasm0(pool_config, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayJsValueToWasm0(pre_decisions, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.build_workflow_fuzzy_schedule(template, ptr0, len0, ptr1, len1, !isLikeNone(resolution), isLikeNone(resolution) ? 0 : resolution, !isLikeNone(units_per_day), isLikeNone(units_per_day) ? 0 : units_per_day);
    return ret;
}

/**
 * @param {WorkflowTemplateState} template_state
 * @param {WorkflowEvent[]} events
 * @returns {WorkflowState}
 */
export function build_workflow_state(template_state, events) {
    const ptr0 = passArrayJsValueToWasm0(events, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.build_workflow_state(template_state, ptr0, len0);
    return ret;
}

/**
 * @param {WorkflowTemplateEvent[]} events
 * @returns {WorkflowTemplateState}
 */
export function build_workflow_template_state(events) {
    const ptr0 = passArrayJsValueToWasm0(events, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.build_workflow_template_state(ptr0, len0);
    return ret;
}

/**
 * @param {WorkflowState} workflow_state
 * @param {string} user_id
 * @returns {WorkflowUserDisplayState}
 */
export function build_workflow_user_display_state(workflow_state, user_id) {
    const ptr0 = passStringToWasm0(user_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.build_workflow_user_display_state(workflow_state, ptr0, len0);
    return ret;
}

/**
 * @param {SafeData} safe_data
 * @param {string} team_id
 * @param {string} person_id
 * @param {string} target_date
 * @param {DraftAllocationDto[]} drafts
 * @returns {Promise<CandidateTasksReport>}
 */
export function candidate_tasks(safe_data, team_id, person_id, target_date, drafts) {
    _assertClass(safe_data, SafeData);
    const ptr0 = passStringToWasm0(team_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(person_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(target_date, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayJsValueToWasm0(drafts, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.candidate_tasks(safe_data.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    return ret;
}

/**
 * Compute the CQRS events needed to transform `current` into `desired`.
 *
 * Returns a list of `WorkflowTemplateEventData` that, when applied to the
 * current state, will produce the desired state.
 * @param {WorkflowTemplateState} current
 * @param {WorkflowTemplateState} desired
 * @returns {WorkflowTemplateEventData[]}
 */
export function diff_workflow_template_states(current, desired) {
    const ret = wasm.diff_workflow_template_states(current, desired);
    var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * Scan a template and return all parameter keys it references, with their expected types.
 * Type is one of `"Bool"`, `"Worker"`, or `"String"`.
 * @param {WorkflowTemplateState} template
 * @returns {Array<any>}
 */
export function discover_workflow_parameters(template) {
    const ret = wasm.discover_workflow_parameters(template);
    return ret;
}

/**
 * @param {SafeData} safe_data
 * @param {NodeMatcher} object
 * @returns {WorkMatch[]}
 */
export function get_relevant_matches_for_object(safe_data, object) {
    _assertClass(safe_data, SafeData);
    const ret = wasm.get_relevant_matches_for_object(safe_data.__wbg_ptr, object);
    return ret;
}

/**
 * @param {SafeData} safe_data
 * @param {PersonOrTeam} person_or_team
 * @returns {WorkMatch[]}
 */
export function get_relevant_matches_for_person_or_team(safe_data, person_or_team) {
    _assertClass(safe_data, SafeData);
    const ret = wasm.get_relevant_matches_for_person_or_team(safe_data.__wbg_ptr, person_or_team);
    return ret;
}

/**
 * @param {SafeData} safe_data
 * @returns {TidyActions}
 */
export function get_tidy_actions(safe_data) {
    _assertClass(safe_data, SafeData);
    const ret = wasm.get_tidy_actions(safe_data.__wbg_ptr);
    return ret;
}

/**
 * Install a GitLab webhook for a project or group
 *
 * # Arguments
 *
 * * `token` - GitLab API token
 * * `webhook_url` - URL where webhook events should be sent
 * * `webhook_secret` - Secret token to secure the webhook
 * * `target_type` - Either "project" or "group"
 * * `target_id` - The ID of the GitLab project or group
 *
 * # Returns
 *
 * * `true` if the webhook was successfully installed, `false` if it already exists
 * @param {ProviderToken} token
 * @param {string} workspace_id
 * @param {string} webhook_secret
 * @param {string} target_type
 * @param {string} target_id
 * @param {string} api_base_url
 * @returns {Promise<boolean>}
 */
export function install_gitlab_webhook(token, workspace_id, webhook_secret, target_type, target_id, api_base_url) {
    const ptr0 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(webhook_secret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passStringToWasm0(target_type, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passStringToWasm0(target_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passStringToWasm0(api_base_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len4 = WASM_VECTOR_LEN;
    const ret = wasm.install_gitlab_webhook(token, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
    return ret;
}

/**
 * @param {ApiClient} client
 * @param {string} token
 * @returns {Promise<ListUserProfilesResponse>}
 */
export function list_user_profiles(client, token) {
    _assertClass(client, ApiClient);
    const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.list_user_profiles(client.__wbg_ptr, ptr0, len0);
    return ret;
}

/**
 * @param {ApiClient} client
 * @param {string} token
 * @returns {Promise<ListWorkspaceAuthorizationsResponse>}
 */
export function list_viewer_workspace_authorizations(client, token) {
    _assertClass(client, ApiClient);
    const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.list_viewer_workspace_authorizations(client.__wbg_ptr, ptr0, len0);
    return ret;
}

/**
 * @param {ApiClient} client
 * @param {string} token
 * @returns {Promise<ListWorkspacesResponse>}
 */
export function list_viewer_workspaces(client, token) {
    _assertClass(client, ApiClient);
    const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.list_viewer_workspaces(client.__wbg_ptr, ptr0, len0);
    return ret;
}

/**
 * @param {ApiClient} client
 * @param {string} token
 * @param {string} workspace_id
 * @param {PaginationRequestQueryParameters} query_parameters
 * @returns {Promise<Paginated>}
 */
export function list_workspace_events(client, token, workspace_id, query_parameters) {
    _assertClass(client, ApiClient);
    const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(workspace_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.list_workspace_events(client.__wbg_ptr, ptr0, len0, ptr1, len1, query_parameters);
    return ret;
}

/**
 * @param {ApiClient} client
 * @param {string} token
 * @returns {Promise<ListWorkspacesResponse>}
 */
export function list_workspaces(client, token) {
    _assertClass(client, ApiClient);
    const ptr0 = passStringToWasm0(token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.list_workspaces(client.__wbg_ptr, ptr0, len0);
    return ret;
}

export function main() {
    wasm.main();
}

/**
 * @param {SafeData} safe_data
 * @param {DataSource} data_source
 * @param {ProviderToken} token
 * @param {ImportOptions} options
 * @returns {Promise<ImportActionCommandAndDescription[]>}
 */
export function perform_data_source_import(safe_data, data_source, token, options) {
    _assertClass(safe_data, SafeData);
    const ret = wasm.perform_data_source_import(safe_data.__wbg_ptr, data_source, token, options);
    return ret;
}

/**
 * For use in querying the list of workspace priorities:
 *
 * * with associated information like progress, task count, deadlines, and people scheduled / people matched
 * * whether they are a dependency of another listed priority
 * @param {SafeData} data
 * @param {BoundedEstimateSelector} estimate_selector
 * @returns {PriorityWithAssociatedData[]}
 */
export function priority_view(data, estimate_selector) {
    _assertClass(data, SafeData);
    const ret = wasm.priority_view(data.__wbg_ptr, estimate_selector);
    return ret;
}

/**
 * Render a workflow template title against instance parameter values.
 * `parameters` is an array of `[key, ParameterValue]` pairs (same format as render_workflow_template).
 * Returns the rendered title string.
 * @param {string} template_title
 * @param {(Array<any>)[]} parameters
 * @returns {string}
 */
export function render_workflow_instance_title(template_title, parameters) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(template_title, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(parameters, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.render_workflow_instance_title(ptr0, len0, ptr1, len1);
        deferred3_0 = ret[0];
        deferred3_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * Render a workflow template against a concrete parameter map.
 *
 * Steps with failing inclusion conditions are removed (along with their edges),
 * Tera templates in titles/descriptions are expanded, and `Parameter` authorization
 * subjects are resolved to the concrete person or team.
 *
 * Returns `null` and logs an error to the console on failure.
 * @param {WorkflowTemplateState} template
 * @param {(Array<any>)[]} parameters
 * @returns {WorkflowTemplateState | undefined}
 */
export function render_workflow_template(template, parameters) {
    const ptr0 = passArrayJsValueToWasm0(parameters, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.render_workflow_template(template, ptr0, len0);
    return ret;
}

/**
 * Search across all entity types by plain case-insensitive substring match on title/name.
 * Delegates to `Database::search_all` and serializes for the JS boundary.
 * @param {SafeData} data
 * @param {string} query
 * @param {number | null} [limit]
 * @returns {SearchResult[]}
 */
export function search_all(data, query, limit) {
    _assertClass(data, SafeData);
    const ptr0 = passStringToWasm0(query, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.search_all(data.__wbg_ptr, ptr0, len0, isLikeNone(limit) ? 0x100000001 : (limit) >>> 0);
    return ret;
}

/**
 * Search for decisions in the database by title string match.
 * @param {SafeData} data
 * @param {string} query
 * @param {number | null} [limit]
 * @returns {Promise<DecisionWithAssociatedData[]>}
 */
export function search_decisions(data, query, limit) {
    _assertClass(data, SafeData);
    const ptr0 = passStringToWasm0(query, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.search_decisions(data.__wbg_ptr, ptr0, len0, isLikeNone(limit) ? 0x100000001 : (limit) >>> 0);
    return ret;
}

/**
 * Search for the first `limit` tasks or outcomes in the database by title string match.
 * @param {SafeData} data
 * @param {string} query
 * @param {number} limit
 * @returns {Promise<DependencyWithAssociatedData[]>}
 */
export function search_dependencies(data, query, limit) {
    _assertClass(data, SafeData);
    const ptr0 = passStringToWasm0(query, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.search_dependencies(data.__wbg_ptr, ptr0, len0, limit);
    return ret;
}

/**
 * Return the first `limit` outcomes that match the given filter.
 * @param {SafeData} data
 * @param {NodeFilter} query
 * @param {number | null} [limit]
 * @returns {Promise<OutcomeWithAssociatedData[]>}
 */
export function search_outcomes(data, query, limit) {
    _assertClass(data, SafeData);
    const ret = wasm.search_outcomes(data.__wbg_ptr, query, isLikeNone(limit) ? 0x100000001 : (limit) >>> 0);
    return ret;
}

/**
 * Search for people in the database by name string match.
 * @param {SafeData} data
 * @param {string} query
 * @param {number | null} [limit]
 * @returns {Promise<PersonWithAssociatedData[]>}
 */
export function search_people(data, query, limit) {
    _assertClass(data, SafeData);
    const ptr0 = passStringToWasm0(query, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.search_people(data.__wbg_ptr, ptr0, len0, isLikeNone(limit) ? 0x100000001 : (limit) >>> 0);
    return ret;
}

/**
 * Search for the first `limit` tasks or outcomes in the database by title string match.
 * @param {SafeData} data
 * @param {string} query
 * @param {number} limit
 * @param {boolean} include_completed_tasks
 * @returns {Promise<PrioritySearchResultItem[]>}
 */
export function search_priorities(data, query, limit, include_completed_tasks) {
    _assertClass(data, SafeData);
    const ptr0 = passStringToWasm0(query, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.search_priorities(data.__wbg_ptr, ptr0, len0, limit, include_completed_tasks);
    return ret;
}

/**
 * Search for projects in the database by name string match.
 * @param {SafeData} data
 * @param {string} query
 * @param {number | null} [limit]
 * @returns {Promise<ProjectWithAssociatedData[]>}
 */
export function search_projects(data, query, limit) {
    _assertClass(data, SafeData);
    const ptr0 = passStringToWasm0(query, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.search_projects(data.__wbg_ptr, ptr0, len0, isLikeNone(limit) ? 0x100000001 : (limit) >>> 0);
    return ret;
}

/**
 * Search for stakeholders in the database by name string match.
 * @param {SafeData} data
 * @param {string} query
 * @param {number | null} [limit]
 * @returns {Promise<StakeholderWithAssociatedData[]>}
 */
export function search_stakeholders(data, query, limit) {
    _assertClass(data, SafeData);
    const ptr0 = passStringToWasm0(query, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.search_stakeholders(data.__wbg_ptr, ptr0, len0, isLikeNone(limit) ? 0x100000001 : (limit) >>> 0);
    return ret;
}

/**
 * Search for the first `limit` tasks in the database by title string match.
 * @param {SafeData} data
 * @param {NodeFilter} query
 * @param {number | null} [limit]
 * @returns {Promise<TaskWithAssociatedData[]>}
 */
export function search_tasks(data, query, limit) {
    _assertClass(data, SafeData);
    const ret = wasm.search_tasks(data.__wbg_ptr, query, isLikeNone(limit) ? 0x100000001 : (limit) >>> 0);
    return ret;
}

/**
 * Search for teams in the database by name string match.
 * @param {SafeData} data
 * @param {string} query
 * @param {number | null} [limit]
 * @returns {Promise<TeamWithAssociatedData[]>}
 */
export function search_teams(data, query, limit) {
    _assertClass(data, SafeData);
    const ptr0 = passStringToWasm0(query, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.search_teams(data.__wbg_ptr, ptr0, len0, isLikeNone(limit) ? 0x100000001 : (limit) >>> 0);
    return ret;
}

/**
 * Search for workflow instances in the database by template_id string match.
 * @param {SafeData} data
 * @param {string} query
 * @param {number | null} [limit]
 * @returns {Promise<WorkflowInstanceWithAssociatedData[]>}
 */
export function search_workflow_instances(data, query, limit) {
    _assertClass(data, SafeData);
    const ptr0 = passStringToWasm0(query, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.search_workflow_instances(data.__wbg_ptr, ptr0, len0, isLikeNone(limit) ? 0x100000001 : (limit) >>> 0);
    return ret;
}

/**
 * @param {string} s
 * @returns {string}
 */
export function slugify(s) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ptr0 = passStringToWasm0(s, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.slugify(ptr0, len0);
        deferred2_0 = ret[0];
        deferred2_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * @returns {string}
 */
export function uuidv4() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.uuidv4();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg_Error_960c155d3d49e4c2: function(arg0, arg1) {
            const ret = Error(getStringFromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_String_11905339415cf58e: function(arg0, arg1) {
            const ret = String(arg1);
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_bigint_get_as_i64_3d3aba5d616c6a51: function(arg0, arg1) {
            const v = arg1;
            const ret = typeof(v) === 'bigint' ? v : undefined;
            getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
        },
        __wbg___wbindgen_boolean_get_6ea149f0a8dcc5ff: function(arg0) {
            const v = arg0;
            const ret = typeof(v) === 'boolean' ? v : undefined;
            return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
        },
        __wbg___wbindgen_debug_string_ab4b34d23d6778bd: function(arg0, arg1) {
            const ret = debugString(arg1);
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_in_a5d8b22e52b24dd1: function(arg0, arg1) {
            const ret = arg0 in arg1;
            return ret;
        },
        __wbg___wbindgen_is_bigint_ec25c7f91b4d9e93: function(arg0) {
            const ret = typeof(arg0) === 'bigint';
            return ret;
        },
        __wbg___wbindgen_is_function_3baa9db1a987f47d: function(arg0) {
            const ret = typeof(arg0) === 'function';
            return ret;
        },
        __wbg___wbindgen_is_null_52ff4ec04186736f: function(arg0) {
            const ret = arg0 === null;
            return ret;
        },
        __wbg___wbindgen_is_object_63322ec0cd6ea4ef: function(arg0) {
            const val = arg0;
            const ret = typeof(val) === 'object' && val !== null;
            return ret;
        },
        __wbg___wbindgen_is_string_6df3bf7ef1164ed3: function(arg0) {
            const ret = typeof(arg0) === 'string';
            return ret;
        },
        __wbg___wbindgen_is_undefined_29a43b4d42920abd: function(arg0) {
            const ret = arg0 === undefined;
            return ret;
        },
        __wbg___wbindgen_jsval_eq_d3465d8a07697228: function(arg0, arg1) {
            const ret = arg0 === arg1;
            return ret;
        },
        __wbg___wbindgen_jsval_loose_eq_cac3565e89b4134c: function(arg0, arg1) {
            const ret = arg0 == arg1;
            return ret;
        },
        __wbg___wbindgen_number_get_c7f42aed0525c451: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof(obj) === 'number' ? obj : undefined;
            getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
        },
        __wbg___wbindgen_string_get_7ed5322991caaec5: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof(obj) === 'string' ? obj : undefined;
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_throw_6b64449b9b9ed33c: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg__wbg_cb_unref_b46c9b5a9f08ec37: function(arg0) {
            arg0._wbg_cb_unref();
        },
        __wbg_abort_4ce5b484434ef6fd: function(arg0) {
            arg0.abort();
        },
        __wbg_abort_d53712380a54cc81: function(arg0, arg1) {
            arg0.abort(arg1);
        },
        __wbg_append_e8fc56ce7c00e874: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
            arg0.append(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
        }, arguments); },
        __wbg_arrayBuffer_848c392b70c67d3d: function() { return handleError(function (arg0) {
            const ret = arg0.arrayBuffer();
            return ret;
        }, arguments); },
        __wbg_call_14b169f759b26747: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.call(arg1);
            return ret;
        }, arguments); },
        __wbg_call_a24592a6f349a97e: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.call(arg1, arg2);
            return ret;
        }, arguments); },
        __wbg_clearTimeout_2256f1e7b94ef517: function(arg0) {
            const ret = clearTimeout(arg0);
            return ret;
        },
        __wbg_close_a7d2c11ae747c112: function(arg0) {
            arg0.close();
        },
        __wbg_createIndex_b7dc3a4f19fc4231: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
            const ret = arg0.createIndex(getStringFromWasm0(arg1, arg2), arg3, arg4);
            return ret;
        }, arguments); },
        __wbg_createObjectStore_9cf3048eb7b47bc2: function() { return handleError(function (arg0, arg1, arg2, arg3) {
            const ret = arg0.createObjectStore(getStringFromWasm0(arg1, arg2), arg3);
            return ret;
        }, arguments); },
        __wbg_crypto_38df2bab126b63dc: function(arg0) {
            const ret = arg0.crypto;
            return ret;
        },
        __wbg_decisionwithassociateddata_new: function(arg0) {
            const ret = DecisionWithAssociatedData.__wrap(arg0);
            return ret;
        },
        __wbg_deleteIndex_99722fe825533212: function() { return handleError(function (arg0, arg1, arg2) {
            arg0.deleteIndex(getStringFromWasm0(arg1, arg2));
        }, arguments); },
        __wbg_deleteObjectStore_081280ffb13f9792: function() { return handleError(function (arg0, arg1, arg2) {
            arg0.deleteObjectStore(getStringFromWasm0(arg1, arg2));
        }, arguments); },
        __wbg_dependencywithassociateddata_new: function(arg0) {
            const ret = DependencyWithAssociatedData.__wrap(arg0);
            return ret;
        },
        __wbg_done_9158f7cc8751ba32: function(arg0) {
            const ret = arg0.done;
            return ret;
        },
        __wbg_entries_bf727fcd7bf35a41: function(arg0) {
            const ret = arg0.entries();
            return ret;
        },
        __wbg_entries_e0b73aa8571ddb56: function(arg0) {
            const ret = Object.entries(arg0);
            return ret;
        },
        __wbg_error_2001591ad2463697: function(arg0) {
            console.error(arg0);
        },
        __wbg_error_43690a185e0311ac: function() { return handleError(function (arg0) {
            const ret = arg0.error;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        }, arguments); },
        __wbg_error_a6fa202b58aa1cd3: function(arg0, arg1) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                console.error(getStringFromWasm0(arg0, arg1));
            } finally {
                wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_fetch_0d322c0aed196b8b: function(arg0, arg1) {
            const ret = arg0.fetch(arg1);
            return ret;
        },
        __wbg_fetch_43b2f110608a59ff: function(arg0) {
            const ret = fetch(arg0);
            return ret;
        },
        __wbg_fetch_fda7bc27c982b1f3: function(arg0) {
            const ret = fetch(arg0);
            return ret;
        },
        __wbg_getRandomValues_c44a50d8cfdaebeb: function() { return handleError(function (arg0, arg1) {
            arg0.getRandomValues(arg1);
        }, arguments); },
        __wbg_getRandomValues_d49329ff89a07af1: function() { return handleError(function (arg0, arg1) {
            globalThis.crypto.getRandomValues(getArrayU8FromWasm0(arg0, arg1));
        }, arguments); },
        __wbg_getTime_da7c55f52b71e8c6: function(arg0) {
            const ret = arg0.getTime();
            return ret;
        },
        __wbg_getTimezoneOffset_31f57a5389d0d57c: function(arg0) {
            const ret = arg0.getTimezoneOffset();
            return ret;
        },
        __wbg_get_1affdbdd5573b16a: function() { return handleError(function (arg0, arg1) {
            const ret = Reflect.get(arg0, arg1);
            return ret;
        }, arguments); },
        __wbg_get_59664ef421721a7e: function(arg0, arg1, arg2) {
            const ret = arg1[arg2 >>> 0];
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_get_6011fa3a58f61074: function() { return handleError(function (arg0, arg1) {
            const ret = Reflect.get(arg0, arg1);
            return ret;
        }, arguments); },
        __wbg_get_803cfa78503173c3: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.get(arg1);
            return ret;
        }, arguments); },
        __wbg_get_8360291721e2339f: function(arg0, arg1) {
            const ret = arg0[arg1 >>> 0];
            return ret;
        },
        __wbg_get_unchecked_17f53dad852b9588: function(arg0, arg1) {
            const ret = arg0[arg1 >>> 0];
            return ret;
        },
        __wbg_get_with_ref_key_f38bf27dc398d91b: function(arg0, arg1) {
            const ret = arg0[arg1];
            return ret;
        },
        __wbg_has_880f1d472f7cecba: function() { return handleError(function (arg0, arg1) {
            const ret = Reflect.has(arg0, arg1);
            return ret;
        }, arguments); },
        __wbg_headers_6022deb4e576fb8e: function(arg0) {
            const ret = arg0.headers;
            return ret;
        },
        __wbg_indexNames_3e19d9cfe84e3093: function(arg0) {
            const ret = arg0.indexNames;
            return ret;
        },
        __wbg_index_072be17bcbd46242: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.index(getStringFromWasm0(arg1, arg2));
            return ret;
        }, arguments); },
        __wbg_instanceof_ArrayBuffer_7c8433c6ed14ffe3: function(arg0) {
            let result;
            try {
                result = arg0 instanceof ArrayBuffer;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_IdbDatabase_3b6930bc25a91170: function(arg0) {
            let result;
            try {
                result = arg0 instanceof IDBDatabase;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_IdbFactory_8af6762731f44f3b: function(arg0) {
            let result;
            try {
                result = arg0 instanceof IDBFactory;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_IdbOpenDbRequest_d0071b8c6aae51ff: function(arg0) {
            let result;
            try {
                result = arg0 instanceof IDBOpenDBRequest;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_IdbRequest_cb20b218916840b2: function(arg0) {
            let result;
            try {
                result = arg0 instanceof IDBRequest;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Response_9b2d111407865ff2: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Response;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Uint8Array_152ba1f289edcf3f: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Uint8Array;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_isArray_c3109d14ffc06469: function(arg0) {
            const ret = Array.isArray(arg0);
            return ret;
        },
        __wbg_isSafeInteger_4fc213d1989d6d2a: function(arg0) {
            const ret = Number.isSafeInteger(arg0);
            return ret;
        },
        __wbg_is_8f7ba86b7f249abd: function(arg0, arg1) {
            const ret = Object.is(arg0, arg1);
            return ret;
        },
        __wbg_iterator_013bc09ec998c2a7: function() {
            const ret = Symbol.iterator;
            return ret;
        },
        __wbg_keyPath_7160d7cd96c58b79: function() { return handleError(function (arg0) {
            const ret = arg0.keyPath;
            return ret;
        }, arguments); },
        __wbg_length_167a2db2c5f76499: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_length_3d4ecd04bd8d22f1: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_length_9f1775224cf1d815: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_log_0c201ade58bb55e1: function(arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                console.log(getStringFromWasm0(arg0, arg1), getStringFromWasm0(arg2, arg3), getStringFromWasm0(arg4, arg5), getStringFromWasm0(arg6, arg7));
            } finally {
                wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_log_ce2c4456b290c5e7: function(arg0, arg1) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                console.log(getStringFromWasm0(arg0, arg1));
            } finally {
                wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_mark_b4d943f3bc2d2404: function(arg0, arg1) {
            performance.mark(getStringFromWasm0(arg0, arg1));
        },
        __wbg_measure_84362959e621a2c1: function() { return handleError(function (arg0, arg1, arg2, arg3) {
            let deferred0_0;
            let deferred0_1;
            let deferred1_0;
            let deferred1_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                deferred1_0 = arg2;
                deferred1_1 = arg3;
                performance.measure(getStringFromWasm0(arg0, arg1), getStringFromWasm0(arg2, arg3));
            } finally {
                wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
                wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
            }
        }, arguments); },
        __wbg_msCrypto_bd5a034af96bcba6: function(arg0) {
            const ret = arg0.msCrypto;
            return ret;
        },
        __wbg_multiEntry_eb066895143c99c8: function(arg0) {
            const ret = arg0.multiEntry;
            return ret;
        },
        __wbg_new_0_4d657201ced14de3: function() {
            const ret = new Date();
            return ret;
        },
        __wbg_new_0c7403db6e782f19: function(arg0) {
            const ret = new Uint8Array(arg0);
            return ret;
        },
        __wbg_new_15a4889b4b90734d: function() { return handleError(function () {
            const ret = new Headers();
            return ret;
        }, arguments); },
        __wbg_new_227d7c05414eb861: function() {
            const ret = new Error();
            return ret;
        },
        __wbg_new_34d45cc8e36aaead: function() {
            const ret = new Map();
            return ret;
        },
        __wbg_new_682678e2f47e32bc: function() {
            const ret = new Array();
            return ret;
        },
        __wbg_new_7913666fe5070684: function(arg0) {
            const ret = new Date(arg0);
            return ret;
        },
        __wbg_new_98c22165a42231aa: function() { return handleError(function () {
            const ret = new AbortController();
            return ret;
        }, arguments); },
        __wbg_new_aa8d0fa9762c29bd: function() {
            const ret = new Object();
            return ret;
        },
        __wbg_new_from_slice_b5ea43e23f6008c0: function(arg0, arg1) {
            const ret = new Uint8Array(getArrayU8FromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_new_typed_323f37fd55ab048d: function(arg0, arg1) {
            try {
                var state0 = {a: arg0, b: arg1};
                var cb0 = (arg0, arg1) => {
                    const a = state0.a;
                    state0.a = 0;
                    try {
                        return wasm_bindgen__convert__closures_____invoke__h1893412dde9e34a5(a, state0.b, arg0, arg1);
                    } finally {
                        state0.a = a;
                    }
                };
                const ret = new Promise(cb0);
                return ret;
            } finally {
                state0.a = 0;
            }
        },
        __wbg_new_with_length_8c854e41ea4dae9b: function(arg0) {
            const ret = new Uint8Array(arg0 >>> 0);
            return ret;
        },
        __wbg_new_with_str_and_init_897be1708e42f39d: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = new Request(getStringFromWasm0(arg0, arg1), arg2);
            return ret;
        }, arguments); },
        __wbg_new_with_year_month_day_c5da92578bfcdd66: function(arg0, arg1, arg2) {
            const ret = new Date(arg0 >>> 0, arg1, arg2);
            return ret;
        },
        __wbg_next_0340c4ae324393c3: function() { return handleError(function (arg0) {
            const ret = arg0.next();
            return ret;
        }, arguments); },
        __wbg_next_7646edaa39458ef7: function(arg0) {
            const ret = arg0.next;
            return ret;
        },
        __wbg_node_84ea875411254db1: function(arg0) {
            const ret = arg0.node;
            return ret;
        },
        __wbg_objectStoreNames_c755717c02e8876b: function(arg0) {
            const ret = arg0.objectStoreNames;
            return ret;
        },
        __wbg_objectStore_5942e8f91c946be8: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.objectStore(getStringFromWasm0(arg1, arg2));
            return ret;
        }, arguments); },
        __wbg_open_0949b7cdde2ab99a: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.open(getStringFromWasm0(arg1, arg2));
            return ret;
        }, arguments); },
        __wbg_open_90f4e40d36c2c9f5: function() { return handleError(function (arg0, arg1, arg2, arg3) {
            const ret = arg0.open(getStringFromWasm0(arg1, arg2), arg3 >>> 0);
            return ret;
        }, arguments); },
        __wbg_outcomewithassociateddata_new: function(arg0) {
            const ret = OutcomeWithAssociatedData.__wrap(arg0);
            return ret;
        },
        __wbg_parse_29ba05b712596e33: function(arg0, arg1) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                const ret = JSON.parse(getStringFromWasm0(arg0, arg1));
                return ret;
            } finally {
                wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_personwithassociateddata_new: function(arg0) {
            const ret = PersonWithAssociatedData.__wrap(arg0);
            return ret;
        },
        __wbg_prioritysearchresultitem_new: function(arg0) {
            const ret = PrioritySearchResultItem.__wrap(arg0);
            return ret;
        },
        __wbg_process_44c7a14e11e9f69e: function(arg0) {
            const ret = arg0.process;
            return ret;
        },
        __wbg_projectwithassociateddata_new: function(arg0) {
            const ret = ProjectWithAssociatedData.__wrap(arg0);
            return ret;
        },
        __wbg_prototypesetcall_a6b02eb00b0f4ce2: function(arg0, arg1, arg2) {
            Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
        },
        __wbg_push_471a5b068a5295f6: function(arg0, arg1) {
            const ret = arg0.push(arg1);
            return ret;
        },
        __wbg_put_2d1082795891ee40: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.put(arg1);
            return ret;
        }, arguments); },
        __wbg_put_fd02d3070a55994c: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.put(arg1, arg2);
            return ret;
        }, arguments); },
        __wbg_queueMicrotask_5d15a957e6aa920e: function(arg0) {
            queueMicrotask(arg0);
        },
        __wbg_queueMicrotask_f8819e5ffc402f36: function(arg0) {
            const ret = arg0.queueMicrotask;
            return ret;
        },
        __wbg_randomFillSync_6c25eac9869eb53c: function() { return handleError(function (arg0, arg1) {
            arg0.randomFillSync(arg1);
        }, arguments); },
        __wbg_require_b4edbdcf3e2a1ef0: function() { return handleError(function () {
            const ret = module.require;
            return ret;
        }, arguments); },
        __wbg_resolve_e6c466bc1052f16c: function(arg0) {
            const ret = Promise.resolve(arg0);
            return ret;
        },
        __wbg_result_f782323755b96dc8: function() { return handleError(function (arg0) {
            const ret = arg0.result;
            return ret;
        }, arguments); },
        __wbg_safedata_new: function(arg0) {
            const ret = SafeData.__wrap(arg0);
            return ret;
        },
        __wbg_setTimeout_b188b3bcc8977c7d: function(arg0, arg1) {
            const ret = setTimeout(arg0, arg1);
            return ret;
        },
        __wbg_set_022bee52d0b05b19: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = Reflect.set(arg0, arg1, arg2);
            return ret;
        }, arguments); },
        __wbg_set_3bf1de9fab0cd644: function(arg0, arg1, arg2) {
            arg0[arg1 >>> 0] = arg2;
        },
        __wbg_set_auto_increment_12f813bc0f283d18: function(arg0, arg1) {
            arg0.autoIncrement = arg1 !== 0;
        },
        __wbg_set_body_be11680f34217f75: function(arg0, arg1) {
            arg0.body = arg1;
        },
        __wbg_set_cache_968edea422613d1b: function(arg0, arg1) {
            arg0.cache = __wbindgen_enum_RequestCache[arg1];
        },
        __wbg_set_credentials_6577be90e0e85eb6: function(arg0, arg1) {
            arg0.credentials = __wbindgen_enum_RequestCredentials[arg1];
        },
        __wbg_set_d1cb61e9f39c870f: function(arg0, arg1, arg2) {
            arg0[arg1] = arg2;
        },
        __wbg_set_fde2cec06c23692b: function(arg0, arg1, arg2) {
            const ret = arg0.set(arg1, arg2);
            return ret;
        },
        __wbg_set_headers_50fc01786240a440: function(arg0, arg1) {
            arg0.headers = arg1;
        },
        __wbg_set_key_path_23485c4a6cd0c2cf: function(arg0, arg1) {
            arg0.keyPath = arg1;
        },
        __wbg_set_method_c9f1f985f6b6c427: function(arg0, arg1, arg2) {
            arg0.method = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_mode_5e08d503428c06b9: function(arg0, arg1) {
            arg0.mode = __wbindgen_enum_RequestMode[arg1];
        },
        __wbg_set_multi_entry_bda3f2f33c69a070: function(arg0, arg1) {
            arg0.multiEntry = arg1 !== 0;
        },
        __wbg_set_name_5d57bfb5969c422c: function(arg0, arg1, arg2) {
            arg0.name = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_onerror_ed658d0b50b67e95: function(arg0, arg1) {
            arg0.onerror = arg1;
        },
        __wbg_set_onsuccess_bf03d6c06709ef09: function(arg0, arg1) {
            arg0.onsuccess = arg1;
        },
        __wbg_set_onupgradeneeded_3fc8649a687213f5: function(arg0, arg1) {
            arg0.onupgradeneeded = arg1;
        },
        __wbg_set_onversionchange_10702a9be26be1d2: function(arg0, arg1) {
            arg0.onversionchange = arg1;
        },
        __wbg_set_signal_1d4e73c2305a0e7c: function(arg0, arg1) {
            arg0.signal = arg1;
        },
        __wbg_set_unique_0a396b97f5b68657: function(arg0, arg1) {
            arg0.unique = arg1 !== 0;
        },
        __wbg_signal_fdc54643b47bf85b: function(arg0) {
            const ret = arg0.signal;
            return ret;
        },
        __wbg_stack_3b0d974bbf31e44f: function(arg0, arg1) {
            const ret = arg1.stack;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_stakeholderwithassociateddata_new: function(arg0) {
            const ret = StakeholderWithAssociatedData.__wrap(arg0);
            return ret;
        },
        __wbg_static_accessor_GLOBAL_8cfadc87a297ca02: function() {
            const ret = typeof global === 'undefined' ? null : global;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_GLOBAL_THIS_602256ae5c8f42cf: function() {
            const ret = typeof globalThis === 'undefined' ? null : globalThis;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_SELF_e445c1c7484aecc3: function() {
            const ret = typeof self === 'undefined' ? null : self;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_WINDOW_f20e8576ef1e0f17: function() {
            const ret = typeof window === 'undefined' ? null : window;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_status_43e0d2f15b22d69f: function(arg0) {
            const ret = arg0.status;
            return ret;
        },
        __wbg_stringify_057c4027271f8007: function(arg0, arg1) {
            const ret = JSON.stringify(arg1);
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_stringify_91082ed7a5a5769e: function() { return handleError(function (arg0) {
            const ret = JSON.stringify(arg0);
            return ret;
        }, arguments); },
        __wbg_subarray_f8ca46a25b1f5e0d: function(arg0, arg1, arg2) {
            const ret = arg0.subarray(arg1 >>> 0, arg2 >>> 0);
            return ret;
        },
        __wbg_target_6d97e221d11b71b6: function(arg0) {
            const ret = arg0.target;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_taskwithassociateddata_new: function(arg0) {
            const ret = TaskWithAssociatedData.__wrap(arg0);
            return ret;
        },
        __wbg_teamwithassociateddata_new: function(arg0) {
            const ret = TeamWithAssociatedData.__wrap(arg0);
            return ret;
        },
        __wbg_text_595ef75535aa25c1: function() { return handleError(function (arg0) {
            const ret = arg0.text();
            return ret;
        }, arguments); },
        __wbg_then_792e0c862b060889: function(arg0, arg1, arg2) {
            const ret = arg0.then(arg1, arg2);
            return ret;
        },
        __wbg_then_8e16ee11f05e4827: function(arg0, arg1) {
            const ret = arg0.then(arg1);
            return ret;
        },
        __wbg_transaction_246d4ade615944eb: function(arg0) {
            const ret = arg0.transaction;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_transaction_9af5475ca3bd3fa9: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.transaction(arg1, __wbindgen_enum_IdbTransactionMode[arg2]);
            return ret;
        }, arguments); },
        __wbg_unique_55295e4c3d09c162: function(arg0) {
            const ret = arg0.unique;
            return ret;
        },
        __wbg_url_2bf741820e6563a0: function(arg0, arg1) {
            const ret = arg1.url;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_value_ee3a06f4579184fa: function(arg0) {
            const ret = arg0.value;
            return ret;
        },
        __wbg_versions_276b2795b1c6a219: function(arg0) {
            const ret = arg0.versions;
            return ret;
        },
        __wbg_warn_3cc416af27dbdc02: function(arg0) {
            console.warn(arg0);
        },
        __wbg_workflowinstancewithassociateddata_new: function(arg0) {
            const ret = WorkflowInstanceWithAssociatedData.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedconsolidationanalysis_new: function(arg0) {
            const ret = WrappedConsolidationAnalysis.__wrap(arg0);
            return ret;
        },
        __wbg_wrappeddatabase_new: function(arg0) {
            const ret = WrappedDatabase.__wrap(arg0);
            return ret;
        },
        __wbg_wrappeddecisionnode_new: function(arg0) {
            const ret = WrappedDecisionNode.__wrap(arg0);
            return ret;
        },
        __wbg_wrappeddependencygraph_new: function(arg0) {
            const ret = WrappedDependencyGraph.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedoutcome_new: function(arg0) {
            const ret = WrappedOutcome.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedperson_new: function(arg0) {
            const ret = WrappedPerson.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedprioritygraph_new: function(arg0) {
            const ret = WrappedPriorityGraph.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedproblem_new: function(arg0) {
            const ret = WrappedProblem.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedproduct_new: function(arg0) {
            const ret = WrappedProduct.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedrequirement_new: function(arg0) {
            const ret = WrappedRequirement.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedresource_new: function(arg0) {
            const ret = WrappedResource.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedresourcegroup_new: function(arg0) {
            const ret = WrappedResourceGroup.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedresourcereservation_new: function(arg0) {
            const ret = WrappedResourceReservation.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedstakeholder_new: function(arg0) {
            const ret = WrappedStakeholder.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedtask_new: function(arg0) {
            const ret = WrappedTask.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedteam_new: function(arg0) {
            const ret = WrappedTeam.__wrap(arg0);
            return ret;
        },
        __wbg_wrappedworkflowinstance_new: function(arg0) {
            const ret = WrappedWorkflowInstance.__wrap(arg0);
            return ret;
        },
        __wbindgen_cast_0000000000000001: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [Externref], shim_idx: 3666, ret: Result(Unit), inner_ret: Some(Result(Unit)) }, mutable: true }) -> Externref`.
            const ret = makeMutClosure(arg0, arg1, wasm_bindgen__convert__closures_____invoke__hd03c17ece229378f);
            return ret;
        },
        __wbindgen_cast_0000000000000002: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [NamedExternref("Event")], shim_idx: 1928, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
            const ret = makeMutClosure(arg0, arg1, wasm_bindgen__convert__closures_____invoke__hc965b0b5eafdf137);
            return ret;
        },
        __wbindgen_cast_0000000000000003: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [NamedExternref("IDBVersionChangeEvent")], shim_idx: 1058, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
            const ret = makeMutClosure(arg0, arg1, wasm_bindgen__convert__closures_____invoke__hdb077596825ab5f1);
            return ret;
        },
        __wbindgen_cast_0000000000000004: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [], shim_idx: 2550, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
            const ret = makeMutClosure(arg0, arg1, wasm_bindgen__convert__closures_____invoke__he9e13e1efcc37fee);
            return ret;
        },
        __wbindgen_cast_0000000000000005: function(arg0) {
            // Cast intrinsic for `F64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_cast_0000000000000006: function(arg0) {
            // Cast intrinsic for `I64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_cast_0000000000000007: function(arg0, arg1) {
            // Cast intrinsic for `Ref(Slice(U8)) -> NamedExternref("Uint8Array")`.
            const ret = getArrayU8FromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_0000000000000008: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_0000000000000009: function(arg0) {
            // Cast intrinsic for `U64 -> Externref`.
            const ret = BigInt.asUintN(64, arg0);
            return ret;
        },
        __wbindgen_cast_000000000000000a: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("DecisionWithAssociatedData")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_000000000000000b: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("DependencyWithAssociatedData")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_000000000000000c: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("OutcomeWithAssociatedData")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_000000000000000d: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("PendingChange")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_000000000000000e: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("PersonWithAssociatedData")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_000000000000000f: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("PrioritySearchResultItem")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_0000000000000010: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("ProjectWithAssociatedData")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_0000000000000011: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("RemoteReference")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_0000000000000012: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("StakeholderWithAssociatedData")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_0000000000000013: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("TaskWithAssociatedData")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_0000000000000014: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("TeamWithAssociatedData")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_0000000000000015: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("WorkflowInstanceWithAssociatedData")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_cast_0000000000000016: function(arg0, arg1) {
            var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
            wasm.__wbindgen_free(arg0, arg1 * 4, 4);
            // Cast intrinsic for `Vector(NamedExternref("string")) -> Externref`.
            const ret = v0;
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        },
    };
    return {
        __proto__: null,
        "./sched_bg.js": import0,
    };
}

function wasm_bindgen__convert__closures_____invoke__he9e13e1efcc37fee(arg0, arg1) {
    wasm.wasm_bindgen__convert__closures_____invoke__he9e13e1efcc37fee(arg0, arg1);
}

function wasm_bindgen__convert__closures_____invoke__hc965b0b5eafdf137(arg0, arg1, arg2) {
    wasm.wasm_bindgen__convert__closures_____invoke__hc965b0b5eafdf137(arg0, arg1, arg2);
}

function wasm_bindgen__convert__closures_____invoke__hdb077596825ab5f1(arg0, arg1, arg2) {
    wasm.wasm_bindgen__convert__closures_____invoke__hdb077596825ab5f1(arg0, arg1, arg2);
}

function wasm_bindgen__convert__closures_____invoke__hd03c17ece229378f(arg0, arg1, arg2) {
    const ret = wasm.wasm_bindgen__convert__closures_____invoke__hd03c17ece229378f(arg0, arg1, arg2);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

function wasm_bindgen__convert__closures_____invoke__h1893412dde9e34a5(arg0, arg1, arg2, arg3) {
    wasm.wasm_bindgen__convert__closures_____invoke__h1893412dde9e34a5(arg0, arg1, arg2, arg3);
}


const __wbindgen_enum_IdbTransactionMode = ["readonly", "readwrite", "versionchange", "readwriteflush", "cleanup"];


const __wbindgen_enum_RequestCache = ["default", "no-store", "reload", "no-cache", "force-cache", "only-if-cached"];


const __wbindgen_enum_RequestCredentials = ["omit", "same-origin", "include"];


const __wbindgen_enum_RequestMode = ["same-origin", "no-cors", "cors", "navigate"];
const ApiClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_apiclient_free(ptr >>> 0, 1));
const ConsolidationAnalysisFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_consolidationanalysis_free(ptr >>> 0, 1));
const DataManagerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_datamanager_free(ptr >>> 0, 1));
const DatabaseCacheFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_databasecache_free(ptr >>> 0, 1));
const DecisionWithAssociatedDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_decisionwithassociateddata_free(ptr >>> 0, 1));
const DependencyWithAssociatedDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_dependencywithassociateddata_free(ptr >>> 0, 1));
const OutcomeWithAssociatedDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_outcomewithassociateddata_free(ptr >>> 0, 1));
const PersonWithAssociatedDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_personwithassociateddata_free(ptr >>> 0, 1));
const PrioritySearchResultItemFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_prioritysearchresultitem_free(ptr >>> 0, 1));
const ProjectWithAssociatedDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_projectwithassociateddata_free(ptr >>> 0, 1));
const SafeDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_safedata_free(ptr >>> 0, 1));
const StakeholderWithAssociatedDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stakeholderwithassociateddata_free(ptr >>> 0, 1));
const TaskWithAssociatedDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_taskwithassociateddata_free(ptr >>> 0, 1));
const TeamWithAssociatedDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_teamwithassociateddata_free(ptr >>> 0, 1));
const WorkflowInstanceWithAssociatedDataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_workflowinstancewithassociateddata_free(ptr >>> 0, 1));
const WrappedApiClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedapiclient_free(ptr >>> 0, 1));
const WrappedConsolidationAnalysisFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedconsolidationanalysis_free(ptr >>> 0, 1));
const WrappedDatabaseFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappeddatabase_free(ptr >>> 0, 1));
const WrappedDecisionNodeFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappeddecisionnode_free(ptr >>> 0, 1));
const WrappedDependencyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappeddependency_free(ptr >>> 0, 1));
const WrappedDependencyGraphFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappeddependencygraph_free(ptr >>> 0, 1));
const WrappedEpochFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedepoch_free(ptr >>> 0, 1));
const WrappedNodeMatcherFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappednodematcher_free(ptr >>> 0, 1));
const WrappedOutcomeFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedoutcome_free(ptr >>> 0, 1));
const WrappedPersonFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedperson_free(ptr >>> 0, 1));
const WrappedPriorityGraphFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedprioritygraph_free(ptr >>> 0, 1));
const WrappedProblemFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedproblem_free(ptr >>> 0, 1));
const WrappedProductFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedproduct_free(ptr >>> 0, 1));
const WrappedRequirementFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedrequirement_free(ptr >>> 0, 1));
const WrappedResourceFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedresource_free(ptr >>> 0, 1));
const WrappedResourceAllocationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedresourceallocation_free(ptr >>> 0, 1));
const WrappedResourceGroupFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedresourcegroup_free(ptr >>> 0, 1));
const WrappedResourceReservationFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedresourcereservation_free(ptr >>> 0, 1));
const WrappedStakeholderFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedstakeholder_free(ptr >>> 0, 1));
const WrappedTaskFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedtask_free(ptr >>> 0, 1));
const WrappedTeamFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedteam_free(ptr >>> 0, 1));
const WrappedTemplateCacheFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedtemplatecache_free(ptr >>> 0, 1));
const WrappedWorkflowInstanceFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wrappedworkflowinstance_free(ptr >>> 0, 1));

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

const CLOSURE_DTORS = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(state => wasm.__wbindgen_destroy_closure(state.a, state.b));

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(wasm.__wbindgen_externrefs.get(mem.getUint32(i, true)));
    }
    wasm.__externref_drop_slice(ptr, len);
    return result;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function makeMutClosure(arg0, arg1, f) {
    const state = { a: arg0, b: arg1, cnt: 1 };
    const real = (...args) => {

        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally {
            state.a = a;
            real._wbg_cb_unref();
        }
    };
    real._wbg_cb_unref = () => {
        if (--state.cnt === 0) {
            wasm.__wbindgen_destroy_closure(state.a, state.b);
            state.a = 0;
            CLOSURE_DTORS.unregister(state);
        }
    };
    CLOSURE_DTORS.register(real, state, state);
    return real;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for (let i = 0; i < array.length; i++) {
        const add = addToExternrefTable0(array[i]);
        getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasm;
function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    wasmModule = module;
    cachedDataViewMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = module.ok && expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('sched_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
